import image1 from "../assets/e-commarce/1.png";
import image2 from "../assets/e-commarce/2.png";
import image3 from "../assets/e-commarce/3.png";
import image4 from "../assets/e-commarce/4.png";
import image5 from "../assets/e-commarce/5.png";
import fireblog1 from "../assets/fireblog/1.png";
import fireblog2 from "../assets/fireblog/2.png";
import fireblog3 from "../assets/fireblog/3.png";
import fireblog4 from "../assets/fireblog/4.png";
import fireblog5 from "../assets/fireblog/5.png";
import recipe1 from "../assets/recipe/aboutpage.png";
import recipe2 from "../assets/recipe/contactpage.png";
import recipe3 from "../assets/recipe/loginpage.png";
import recipe4 from "../assets/recipe/searchpage.png";
import coins1 from "../assets/coins/loginpage.png";
import coins2 from "../assets/coins/homepage.png";
import coins3 from "../assets/coins/basketpage.png";
import formikImage from "../assets/formik.png";
import randomUser from "../assets/randomuser.png";
import randomUser2 from "../assets/randomuser2.png";
import phonebook from "../assets/phonebook.png";
import chatApp from "../assets/chatapp/chatapp.jpg";
import chatApp2 from "../assets/chatapp/chatapp2.jpg";
import chatApp3 from "../assets/chatapp/chatapp3.jpg";
import weather1 from "../assets/weather/1.jpg"
import weather2 from "../assets/weather/2.jpg"
const product = [
  {
    id: 9,
    name: "Chat App",
    image1: chatApp,
    detailImage: [
      {
        image: chatApp3,
        desc: "Loading Page",
        url: "https://alltash-chat.netlify.app/",
      },
      {
        image: chatApp2,
        desc: "Login Page",
        url: "https://alltash-chat.netlify.app/",
      },
      {
        image: chatApp,
        desc: "Chat Page",
        url: "https://alltash-chat.netlify.app/",
      },
    ],
  },
  {
    id: 1,
    name: "E-Commarce Site",
    image1: image1,
    detailImage: [
      {
        image: image1,
        desc: "Home Page",
        url: "https://paramolsadabenalsam.netlify.app/",
      },
      {
        image: image2,
        desc: "Side Bar",
        url: "https://paramolsadabenalsam.netlify.app/",
      },
      {
        image: image3,
        desc: "Detail Page",
        url: "https://paramolsadabenalsam.netlify.app/",
      },
      {
        image: image4,
        desc: "Detail Page",
        url: "https://paramolsadabenalsam.netlify.app/",
      },
      {
        image: image5,
        desc: "Export With Excel",
        url: "https://paramolsadabenalsam.netlify.app/",
      },
    ],
  },
  {
    id: 2,
    name: "Fire-Blog Site",
    image1: fireblog1,
    detailImage: [
      {
        image: fireblog1,
        desc: "Home Page",
        url: "https://mustafa-altas-myblog-app.netlify.app/",
      },
      {
        image: fireblog2,
        desc: "Login page",
        url: "https://mustafa-altas-myblog-app.netlify.app/",
      },
      {
        image: fireblog3,
        desc: "Detail Page",
        url: "https://mustafa-altas-myblog-app.netlify.app/",
      },
      {
        image: fireblog4,
        desc: "New Blog Page",
        url: "https://mustafa-altas-myblog-app.netlify.app/",
      },
      {
        image: fireblog5,
        desc: "Detail Page(Delete Update)",
        url: "https://mustafa-altas-myblog-app.netlify.app/",
      },
    ],
  },
  {
    id: 3,
    name: "Recipe Site",
    image1: recipe1,
    detailImage: [
      {
        image: recipe3,
        desc: "Login Page",
        url: "https://mustafaaltas.github.io/recipes-sites/",
      },
      {
        image: recipe2,
        desc: "Contact page",
        url: "https://mustafaaltas.github.io/recipes-sites/",
      },
      {
        image: recipe1,
        desc: "About Page",
        url: "https://mustafaaltas.github.io/recipes-sites/",
      },
      {
        image: recipe4,
        desc: "Search Page",
        url: "https://mustafaaltas.github.io/recipes-sites/",
      },
    ],
  },
  {
    id: 10,
    name: "Turkey Weather",
    image1: weather1,
    detailImage: [
      {
        image: weather1,
        desc: "Home Page",
        url: "https://turkey-weather-react.netlify.app/",
      },
      {
        image: weather2,
        desc: "İnfo Page",
        url: "https://turkey-weather-react.netlify.app/",
      },
    ],
  },
  {
    id: 4,
    name: "250 Coins Site",
    image1: coins2,
    detailImage: [
      {
        image: coins1,
        desc: "Login Page",
        url: "https://mustafaaltas.github.io/crypto-coins/",
      },
      {
        image: coins2,
        desc: "Home page",
        url: "https://mustafaaltas.github.io/crypto-coins/",
      },
      {
        image: coins3,
        desc: "Basket Page",
        url: "https://mustafaaltas.github.io/crypto-coins/",
      },
    ],
  },
  {
    id: 5,
    name: "Formik Validation Site",
    image1: formikImage,
    detailImage: [
      {
        image: formikImage,
        desc: "Login Page",
        url: "https://register-page-altas.netlify.app/",
      },
    ],
  },
  {
    id: 6,
    name: "Random User Site",
    image1: randomUser,
    detailImage: [
      {
        image: randomUser,
        desc: "Home Page",
        url: "https://altas-random-user-app.netlify.app/",
      },
    ],
  },
  {
    id: 7,
    name: "Random User Site 2 ",
    image1: randomUser2,
    detailImage: [
      {
        image: randomUser2,
        desc: "Home Page",
        url: "https://mustafaaltas.github.io/random-user-2/",
      },
    ],
  },
  {
    id: 8,
    name: "Contact App",
    image1: phonebook,
    detailImage: [
      {
        image: phonebook,
        desc: "Home Page",
        url: "https://phonebook-mustafa.netlify.app",
      },
    ],
  },
];

export default product;
